export const palette = {
  primary: {
    main: '#1c66f6',
    light: '#99c2ff',
    dark: '#0052cc',
    contrastText: '#ffffff',
    100: '#e1effe',
    700: '#0052cc',
  },
  secondary: {
    main: '#ec7d0d',
  },
  warning: {
    main: '#f64c4c',
  },
  error: {
    main: '#f64c4c',
    light: '#fccfcf',
    50: '#fee7e7',
  },
  info: {
    main: '#ced2da',
  },
  success: {
    main: '#def7ec',
    light: '#9fdfbf',
    dark: '#309161',
    100: '#d9f2e5',
  },
  text: {
    primary: '#141c24',
    secondary: '#637083',
    disabled: '#90a0b7',
  },
  neutral: {
    100: '#f2f4f7',
    200: '#e4e7ec',
    300: '#ced2da',
    500: '#637083',
  },
  custom: {
    navBg: '#f6f9ff',
    navSelected: '#cadcfd',
    stroke1: '#eceff5',
    stroke2: '#e4edfe',
    widgetBg: '#fafcff',
    gray1: '#333333',
    alertError: '#e08d8d',
    tagFontColor: '#90a0b7',
    tagInputBorder: '#a6b1c1',
    tagsInputBorder: '#c2cfe0',
    gradientSuccess: 'linear-gradient(80deg, #40bf7f 0%, #7ad65c 100%)',
  },
};

export const cssVariables = `
  :root {
    --mui-palette-primary-main: ${palette.primary.main};
    --mui-palette-primary-light: ${palette.primary.light};
    --mui-palette-primary-dark: ${palette.primary.dark};
    --mui-palette-primary-contrastText: ${palette.primary.contrastText};
    --mui-palette-primary-100: ${palette.primary[100]};
    --mui-palette-primary-700: ${palette.primary[700]};

    --mui-palette-secondary-main: ${palette.secondary.main};

    --mui-palette-warning-main: ${palette.warning.main};

    --mui-palette-error-main: ${palette.error.main};
    --mui-palette-error-light: ${palette.error.light};
    --mui-palette-error-50: ${palette.error[50]};

    --mui-palette-info-main: ${palette.info.main};

    --mui-palette-success-main: ${palette.success.main};
    --mui-palette-success-light: ${palette.success.light};
    --mui-palette-success-dark: ${palette.success.dark};
    --mui-palette-success-100: ${palette.success[100]};

    --mui-palette-text-primary: ${palette.text.primary};
    --mui-palette-text-secondary: ${palette.text.secondary};

    --mui-palette-neutral-100: ${palette.neutral[100]};
    --mui-palette-neutral-200: ${palette.neutral[200]};
    --mui-palette-neutral-300: ${palette.neutral[300]};
    --mui-palette-neutral-500: ${palette.neutral[500]};

    --mui-palette-common-white: #ffffff;

    --mui-palette-custom-navBg: ${palette.custom.navBg};
    --mui-palette-custom-navSelected: ${palette.custom.navSelected};
    --mui-palette-custom-stroke1: ${palette.custom.stroke1};
    --mui-palette-custom-stroke2: ${palette.custom.stroke2};
    --mui-palette-custom-widgetBg: ${palette.custom.widgetBg};
    --mui-palette-custom-gray1: ${palette.custom.gray1};
    --mui-palette-custom-alertError: ${palette.custom.alertError};
    --mui-palette-custom-tagFontColor: ${palette.custom.tagFontColor};
    --mui-palette-custom-tagInputBorder: ${palette.custom.tagInputBorder};
    --mui-palette-custom-tagsInputBorder: ${palette.custom.tagsInputBorder};
    --mui-palette-custom-gradientSuccess: ${palette.custom.gradientSuccess};
  }
`;
